import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "../lib/apiClient";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    const trimmedEmail = email.trim().toLowerCase();
    if (!EMAIL_REGEX.test(trimmedEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      await apiRequest("/auth/password/reset-request", {
        method: "POST",
        auth: false,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmedEmail }),
      });

      setSuccess(true);
    } catch (err) {
      setError(err?.message || "Could not send reset link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="app-surface">
      <section className="auth-card">
        {!success ? (
          <>
            <h1>Forgot Password</h1>
            <p>Enter your email and we will send you a reset link.</p>

            <form onSubmit={handleSubmit} className="auth-form">
              <label htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                disabled={loading}
              />

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            {error && <p className="form-error">{error}</p>}

            <p className="auth-footnote">
              <Link to="/app/login">Back to Sign In</Link>
            </p>
          </>
        ) : (
          <>
            <h1>Check your email</h1>
            <p>
              If an account exists for that email address, a password reset link
              has been sent.
            </p>
            <p className="auth-footnote">
              <Link to="/app/login">Back to Sign In</Link>
            </p>
          </>
        )}
      </section>
    </main>
  );
}
